export default __webpack_public_path__ + "static/media/_plus.19a5883d.svg";